module.exports = __webpack_public_path__ + "static/media/imposte-e-tasse.b375c90e.odt";